// extracted by mini-css-extract-plugin
module.exports = {"DocumentsList":"DocumentsList_DocumentsList__2si09","EmptyState":"DocumentsList_EmptyState__1vF5V"};